import 'pixi.js/dist/pixi.min.js';

import "./libs/pixi-display.js";

import prepare from './main.js';

window.prepare = prepare;


// WEBPACK FOOTER //
// ./src/app.js